import {getAppletOrWechatLogin} from "@/api/common";

export const appleInit = (clientId, redirectURI) => {
    return new Promise((resolve, reject) => {
        try {
            window.AppleID.auth.init({
                clientId: clientId,
                redirectURI: redirectURI,
                usePopup: true
                // state : '[STATE]'
            });
            resolve()
        } catch (error) {
            reject(error);
        }
    });
}

export const appleSignIn = (clientId, redirectURI) => {
    console.log("开始苹果登录3")
    return new Promise((resolve, reject) => {
        try {
            window.AppleID.auth.signIn({
                clientId: clientId,
                redirectURI: redirectURI,
                usePopup: true
            }).then((ele) => {
                console.log("ele.authorization", ele.authorization)
                getAppletOrWechatLogin(ele.authorization.code, 'apple').then((res) => {
                    resolve(res)
                })
            }).catch(reject);
        } catch (error) {
            reject(error);
        }
    });
}
